import type { ReactNode } from 'react';

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetTitle,
} from '@/components/ui/sheet';

type DetailSheetProps = {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
};

export const DetailSheet = (props: DetailSheetProps) => {
  const { isOpen, title, onClose, children } = props;

  return (
    <Sheet
      open={isOpen}
      onOpenChange={(isSheetOpen) => {
        if (!isSheetOpen) {
          onClose();
        }
      }}
    >
      <SheetContent
        side="right"
        showCloseButton={false}
        className="flex size-full max-w-full flex-col gap-0 p-0 sm:max-w-full"
      >
        <SheetTitle className="sr-only">{title}</SheetTitle>
        <SheetDescription className="sr-only">{title}</SheetDescription>
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
          {children}
        </div>
      </SheetContent>
    </Sheet>
  );
};
